import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { XCircle } from 'lucide-react';

export const PaymentCancel = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#FAFAF7] flex items-center justify-center px-4">
      <Card className="max-w-md w-full p-12 text-center border border-[#E3E5DF]/40 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <XCircle 
          data-testid="payment-cancel-icon" 
          className="w-20 h-20 text-[#C1A58D] mx-auto mb-6" 
        />
        <h1 
          className="text-4xl font-light text-[#2C302E] mb-4"
          style={{fontFamily: 'Cormorant Garamond, serif'}}
          data-testid="payment-cancel-title"
        >
          {t('payment.cancelled')}
        </h1>
        <p 
          className="text-[#2C302E]/70 mb-8 leading-relaxed"
          style={{fontFamily: 'Manrope, sans-serif'}}
        >
          {t('payment.cancelledMessage')}
        </p>
        <Button
          data-testid="back-to-rooms-button"
          onClick={() => navigate('/rooms')}
          className="w-full bg-[#8A9A86] hover:bg-[#7A8A76] text-white rounded-full py-6"
        >
          {t('payment.backToRooms')}
        </Button>
      </Card>
    </div>
  );
};
